/**
 * A definition file's line endings. A textarea's value has LF line breaks
 * only, so the editor works in LF and gives Save the file's own style back:
 * a CRLF file stays CRLF, and its MR changes only the lines that changed.
 */

export type LineEnding = '\n' | '\r\n';

/** The text as a textarea holds it: CRLF and lone CR become LF. */
export function toLf(text: string): string {
  return text.replace(/\r\n?/g, '\n');
}

/** CRLF only when every line break is; a mixed or LF file is LF. */
export function lineEndingOf(text: string | null): LineEnding {
  if (text === null || !text.includes('\r\n')) return '\n';
  return /(^|[^\r])\n|\r(?!\n)/.test(text) ? '\n' : '\r\n';
}

/** LF text in the given style. */
export function withLineEnding(text: string, ending: LineEnding): string {
  return ending === '\n' ? text : text.replace(/\n/g, '\r\n');
}
